import { WithSkeleton } from '@capsicum/common';
import { Divider, ListCard, Skeleton, SkeletonItem } from '@capsicum/common-web';
import {
	type NCWConfirmTransferAddressCardComponentProps,
	useNCWConfirmTransferAddressCard
} from '@capsicum/features/nc-wallet/shared';
import { Fragment } from 'react';
import styled from 'styled-components';

import { CopyableAddress } from './CopyableAddress';

const NCWConfirmTransferAddressCardSkeleton = () => {
	const rowContainers = new Array(7).fill(0).map((_, index) => (
		<Fragment key={index}>
			{index > 0 && <S.NetworkDivider orientation="horizontal" />}
			<S.RowContainer>
				<S.SkeletonRowLeftItem />
				<S.SkeletonRowRightItem />
			</S.RowContainer>
		</Fragment>
	));

	return (
		<Skeleton>
			<S.Container>
				<S.Content>{rowContainers}</S.Content>
			</S.Container>
		</Skeleton>
	);
};

const NCWConfirmTransferAddressCardComponent = ({
	fromAddress,
	recipient
}: NCWConfirmTransferAddressCardComponentProps) => {
	const { intlTexts } = useNCWConfirmTransferAddressCard();

	return (
		<S.Container>
			<S.Content>
				<S.RowContainer>
					<S.TransactionLabel>{intlTexts.from}</S.TransactionLabel>
					<CopyableAddress address={fromAddress} textAbove={intlTexts.fromWalletWithUs} />
				</S.RowContainer>
				<S.NetworkDivider orientation="horizontal" />
				<S.RowContainer>
					<S.TransactionLabel>{intlTexts.to}</S.TransactionLabel>
					<CopyableAddress address={recipient.blockchainAddress} textAbove={intlTexts.toExternalWallet} />
				</S.RowContainer>
			</S.Content>
		</S.Container>
	);
};

export const NCWConfirmTransferAddressCard = WithSkeleton(
	NCWConfirmTransferAddressCardComponent,
	NCWConfirmTransferAddressCardSkeleton
);

namespace S {
	export const Container = styled(ListCard)`
		height: auto;
	`;

	export const Content = styled(ListCard.Content)`
		padding: ${({ theme }) => theme.spacings.small};
		overflow: hidden;
		display: inline-block;
	`;
	export const TransactionLabel = styled.span`
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.subtle};
	`;
	export const RowContainer = styled.div`
		display: flex;
		justify-content: space-between;
	`;

	export const SkeletonRowLeftItem = styled(SkeletonItem)`
		width: 200px;
	`;
	export const SkeletonRowRightItem = styled(SkeletonItem)`
		width: 80px;
	`;

	export const NetworkDivider = styled(Divider)`
		margin: ${({ theme }) => theme.spacings.xsmall} 0px;
	`;
}
